<!--  -->
<template>
  <div>
    <div class="choosecover chooseitem">
      <div class="text_wei">
        文字内容：
      </div>
      <el-input v-model="linkobj.written" placeholder="请输入展示的文字" />
    </div>
    <div class="choosecover chooseitem">
      <div class="text_wei">
        链接内容：
      </div>
      <el-input v-model="linkobj.linkwritten" placeholder="链接内容" />
    </div>
    <div class="choosecover">
      <div class="text_wei">
        添加链接活动：
      </div>
      <!-- <el-tag @click="addbookactivey">添加书城活动</el-tag> -->
      <div>
        <el-dropdown trigger="click" @command="handleCommand">
          <span class="el-dropdown-link">
            链接活动<i class="el-icon-arrow-down el-icon--right" />
          </span>
          <el-dropdown-menu slot="dropdown">
            <el-dropdown-item v-for="(items,indexr) in linkallarr" :key="indexr" :command="beforeHandleCommand(items.sign,items.identification)">{{ items.type_name }}</el-dropdown-item>
            <!-- <el-dropdown-item command="a">添加书城活动</el-dropdown-item>
            <el-dropdown-item command="b">添加红包活动</el-dropdown-item>
            <el-dropdown-item command="c">添加书城链接活动</el-dropdown-item> -->
          </el-dropdown-menu>
        </el-dropdown>
      </div>

    </div>

    <div class="btn_determine">
      <el-button @click="linkbtn">确定</el-button>
    </div>
    <!-- 书城活动列表 -->
    <el-dialog title="选择活动" :visible.sync="bookctyactivitiesVisible" append-to-body width="40%">
      <bookctyactivities ref="bookctyactivitiesbox" @callbadwr="callbadwr" />
    </el-dialog>
    <!-- 发红包活动列表 -->
    <el-dialog title="选择红包" :visible.sync="redbao" append-to-body width="40%">
      <reddialog ref="chooseredbao" @redcallback="redcallback" />
    </el-dialog>
    <!-- 书城链接活动 -->
    <el-dialog title="选择书城链接" :visible.sync="sclink" append-to-body width="50%">
      <booklinkdialog ref="sclinkview" @sclinkcallback="sclinkcallback" />
    </el-dialog>
  </div>
</template>

<script>
import bookctyactivities from './bookctyactivities.vue'
import reddialog from './reddialog'
import booklinkdialog from './booklinkdialog'
import { getlinktypeslist } from '@/api/sourceMaterial.js'
export default {
  components: {
    bookctyactivities,
    reddialog,
    booklinkdialog
  },
  data() {
    return {
      linkobj: {
        written: '',
        linkwritten: ''
      },
      id: null, // 平台id
      bookctyactivitiesVisible: false,
      redbao: false,
      sclink: false,
      linkallarr: []
    }
  },
  created() {

  },
  mounted() {

  },
  methods: {

    linksend(id) {
      // 平台id
      this.id = id
      console.log('id', id)
      this.getlinktypesalllist()
    },
    // 获取链接类型
    async getlinktypesalllist() {
      const data = await getlinktypeslist({
        platform_id: this.id
      })
      this.linkallarr = data.data
      console.log('data111', data)
    },
    beforeHandleCommand(sign, identification) {
      return {
        'sign': sign,
        'identification': identification
      }
    },
    linkbtn() {
      if (this.linkobj.written === '') {
        this.$message.error('请输入文字内容')
        return
      }
      if (this.linkobj.linkwritten === '') {
        this.$message.error('请输入链接内容')
        return
      }
      this.$emit('linkbtn', this.linkobj)
    },
    // 选择书城活动回调
    callbadwr(val) {
      this.bookctyactivitiesVisible = false
      this.linkobj.linkwritten = ''
      this.linkobj.linkwritten = val.sign
      console.log('val', val)
    },
    // 选择红包活动回调
    redcallback(item, type) {
      this.redbao = false
      this.linkobj.linkwritten = ''
      this.linkobj.linkwritten = item.sign
    },
    sclinkcallback(item) {
      this.sclink = false
      this.linkobj.linkwritten = ''
      this.linkobj.linkwritten = item.sign_template_no
    },
    // addbookactivey() {
    //   this.bookctyactivitiesVisible = true
    //   setTimeout(() => { // 加定时器原因是，子组件页面未渲染处理就做子组件的请求导致失败，稍微延时一下就可解决问题
    //     this.$refs.bookctyactivitiesbox.send(this.id, 1)
    //   }, 100)
    // },
    handleCommand(command) {
      // eslint-disable-next-line eqeqeq
      if (command.identification == 'platform_activity') {
        this.bookctyactivitiesVisible = true
        setTimeout(() => { // 加定时器原因是，子组件页面未渲染处理就做子组件的请求导致失败，稍微延时一下就可解决问题
          this.$refs.bookctyactivitiesbox.send(this.id, 1)
        }, 100)
      }
      // eslint-disable-next-line eqeqeq
      if (command.identification == 'red_packet_activity') {
        this.redbao = true
        setTimeout(() => { // 加定时器原因是，子组件页面未渲染处理就做子组件的请求导致失败，稍微延时一下就可解决问题
          this.$refs.chooseredbao.send(this.id, 1)
        }, 100)
      }
      // eslint-disable-next-line eqeqeq
      if (command.identification == 'platform_promotion_link') {
        this.sclink = true
        setTimeout(() => { // 加定时器原因是，子组件页面未渲染处理就做子组件的请求导致失败，稍微延时一下就可解决问题
          this.$refs.sclinkview.send(this.id)
        }, 100)
      }
      // eslint-disable-next-line eqeqeq
      if (command.identification == '') {
        this.linkobj.linkwritten = ''
        this.linkobj.linkwritten = command.sign
      }
    }
  }
}
</script>
<style scoped>
/* @import url(); 引入css类 */
.choosecover{
  display: flex;
  align-items: center;
}
.chooseitem{
  margin-bottom: 30px;
}
.text_wei {
  flex-shrink: 0;
}
.btn_determine{
  margin-top: 30px;
  text-align: right;
}
</style>
